var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueLoadingOverlay',{attrs:{"active":_vm.isLoading,"is-full-page":true},on:{"update:active":function($event){_vm.isLoading=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }